import React from "react";
import { Paper, Typography, Button } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import styles from "./MaintenanceScreen.module.scss";

const MaintenanceScreen: React.FC = () => {
  return (
    <div className={styles.container}>
      <Paper elevation={3} className={styles.card}>
        <BuildIcon className={styles.icon} />
        <Typography className={styles.title} variant="h4" gutterBottom>
          Scheduled Maintenance
        </Typography>
        <Typography className={styles.description} variant="body1">
          Our systems are currently undergoing scheduled maintenance to improve
          performance and reliability. We’ll be back online shortly.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
        >
          Refresh
        </Button>
        <Typography className={styles.footer} variant="caption" display="block">
          — IT Operations Team
        </Typography>
      </Paper>
    </div>
  );
};

export default MaintenanceScreen;
